import React from 'react';
import './guaranteeBanner.css';

const GuaranteeBanner = () => {
  return (
    <section className="guarantee-banner" data-aos="fade-up" data-aos-duration="1000">
      <div className="container">
        <div className="banner-content">
          <div className="banner-icon" data-aos="zoom-in" data-aos-delay="200">
            <i className="fas fa-award"></i>
          </div>
          <div className="banner-text" data-aos="fade-left" data-aos-delay="300">
            <h2>Our 100% Satisfaction Guarantee</h2>
            <p>
              We stand behind the quality of our work. If you're not completely satisfied with our cleaning service, 
              we'll come back and re-clean the area at no extra cost. Your happiness is our priority!
            </p>
          </div>
          <div className="banner-cta" data-aos="fade-right" data-aos-delay="400">
            <a href="#contact" className="btn guarantee-btn">
              <i className="fas fa-phone-alt"></i> Book Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeBanner;
